import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isSuperAdmin } from "./SuperAdminRoute";

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return null; // O App.js já exibe o spinner de carregamento
  }

  // Se o usuário estiver autenticado, redireciona para o destino adequado.
  // Super-admins restritos (que não sejam gustavo.vieira@hendrios.agency) vão
  // para /recurring-admin; os restantes utilizadores vão para /dashboard.
  if (isAuthenticated) {
    if (isSuperAdmin(user) && user.email?.toLowerCase() !== 'gustavo.vieira@hendrios.agency') {
      return <Navigate to="/recurring-admin" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // Se o usuário não estiver autenticado, renderiza os filhos (que é o componente Login)
  return children;
};

export default AuthWrapper;
